<template>
  <Row>
    <!-- 小视频 -->
    <Col span="8" v-if="currentData&&currentData.length>0">
    <Row class="smallVideo" v-for="(item,idx) in currentData"  :key="idx"  v-if="idx<3"  >
      <Col span="12"  class="pic" >
      <div  :class="idx===currentVideoIndex?'clickVideo clickVideoBorder':'clickVideo'"
        @click="changeVideo(item.logoPic,item.logoMark,idx)">
        <img :src="require(`../imgs/${idx+1}.png`)" />
         <p v-if="idx===currentVideoIndex&&isPlay">正在播放中...</p>
         <p v-if="idx===currentVideoIndex&&isstop">暂停中...</p>
      </div>
      </Col>
      <Col  span="12" class="info"  v-if="idx<3" >
      <span class="topLine"></span>
      <p :class="idx===currentVideoIndex?'smallInfo color4b7ff0':'smallInfo'"
        v-html="item.logoMark?item.logoMark:'暂无景区说明'"></p>
      </Col>
    </Row>
    </Col>
    <!-- 大视频 -->
    <Col span="15"  class="magL">
      <video
      :src="currentUrl"
       width="750"
       height="430"
      controls="controls"
      ref="a_video"> 您的浏览器不支持 video 标签。 </video>
    <p class="bigInfo"  v-html="currentInfo?currentInfo:'暂无景区说明'"></p>
    </Col>
  </Row>
</template>
<script>
export default {
  props: {
    dataArr: {
      type: Array,
      default: []
    }
  },
  watch: {
    dataArr: {
      handler: function (val) {
        if (val.length > 0) {
          this.currentData = val;
          this.currentUrl = val.length > 0 ? val[0].logoPic : '';
          this.currentInfo = val.length > 0 ? val[0].logoMark : '';
        }
      },
      deep: true
    },
  },
  data () {
    return {
      currentData: [],
      currentUrl: '',
      currentInfo: '',
      currentVideoIndex: 0,
      isPlay: false,
      isstop: false
    }
  },
  mounted () {
    let v = this.$refs.a_video;
    v.addEventListener('play', () => {
      this.isPlay = true
      this.isstop = false
    });
    v.addEventListener('pause', () => {
      this.isplay = false;
      this.isstop = true
    })
  },
  methods: {
    changeVideo (url, info, index) {
      this.currentUrl = null;
      setTimeout(() => {
        this.currentUrl = url;
        this.currentInfo = info;
        this.currentVideoIndex = index;
      }, 20)
      setTimeout(() => {
        if (index == 0) {
          this.$refs.a_video.play()
        } else {
          this.$refs.a_video.autoplay = 'autoplay';
        }
      }, (50));
    },
  }
}
</script>
<style lang="less" scoped>
@fontSize14: 14px;
@fontSize12: 12px;
@lineColor: #f0eeeb;
@color: #323233;
@topLineColor: #4b7ff0;
@bgcolor: #000;
@marginBottom: 10px;
@marginleft: 40px;
@bigInfoLH: 40px;
@smallVideoH: 135px;
.ivu-col-span-8 {
  display: block;
  width: 34%;
}
.clickVideoBorder {
  border: 2px solid @topLineColor;
}
.clickVideo {
  box-sizing: border-box;
  &:hover {
    box-sizing: border-box;
    border: 1px solid @topLineColor;
    .smallInfo {
      color: @topLineColor;
    }
  }
  position: relative;
  cursor: pointer;
  display: inline-block;
  width: 200px;
  height: 120px;
  img {
    width: 100%;
    height: 100%;
  }
  p {
    position: absolute;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    width: 100%;
    color: #fff;
    line-height: 30px;
    text-indent: 10px;
  }
}
.color4b7ff0 {
  color: @topLineColor;
}
.smallInfo {
  cursor: pointer;
  font-size: 16px;
  &:hover {
    color: #4b7ff0;
  }
  strong,
  span {
    font-size: @fontSize12 !important;
    display: block;
    width: 100%;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}
.magL {
  margin-left: @marginleft;
  &:hover .bigInfo {
    transition: all 0.5s ease-in;
    opacity: 1 !important;
  }
}
.smallVideo {
  padding-bottom: @marginBottom;
  border-bottom: 1px solid @lineColor;
  margin-bottom: @marginBottom;
  height: @smallVideoH;
  .info {
    overflow: hidden;
    height: 90%;
    padding-left: 10px;
    box-sizing: border-box;
    color: @color;
    font-size: @fontSize14;
    .topLine {
      margin-bottom: 9px;
      display: block;
      background: @topLineColor;
      width: 42px;
      height: 4px;
    }
  }
}
.bigInfo {
  font-size: @fontSize14;
  padding: 8px 5px 8px 5px;
  opacity: 0 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-indent: 20px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #f0eeeb;
  line-height: 28px;
  position: relative;
  top: -432px;
}
</style>
